<template>
  <div class="animated fadeIn">
    <b-row > 
      <b-col sm="12">
        <b-card 
              header-text-variant="white"
              header-tag="header"
              header-bg-variant="dark"
              body-class="alert-dark">
          <div slot="header">
            <i class='fa fa-align-justify'></i><strong>  Pesquisa</strong> <small>Informe os dados</small>
          </div>
          <form @submit.stop.prevent="onPesquisar" >
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="codigo">Código / ID</label>
                  <b-form-input type="text" id="id" placeholder="Opcional - Código ID" v-model="id"></b-form-input>
                </b-form-group>
              </b-col>
              <!--/.col-->
              <b-col sm="8">
                <b-form-group>
                  <label for="codigo">Descrição</label>
                  <b-form-input type="text" id="descricao" placeholder="Opcional - Descrição" v-model="descricao"></b-form-input>
                </b-form-group>
              </b-col>
              
            </b-row>
            
            <!--/.row-->
            <div slot="footer">
              <vue-button-spinner  type="submit" 
                                  :classDefault="'btn-primary'" 
                                  :isLoading="tabela.isLoading" 
                                  :disabled="tabela.isLoading"
                                  :status="tabela.status">
                                  
                <i class="fa fa-search"></i> Pesquisar
              </vue-button-spinner>              
              <b-button type="reset"  variant="secondary"  @click.stop.prevent="limpar()">
                <i class="fa fa-ban"></i> Limpar
              </b-button>
              <b-button type="button"  variant="success"  @click.stop.prevent="novo()">
                <i class="fa fa-plus"></i> Adicionar
              </b-button>
              <!--
              <b-button type="button"  variant="success" @click.stop.prevent="novo()">
                <i class="fa fa-plus"></i> Novo
              </b-button>
              -->
            </div>
          </form>  
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    
    <!--/.row-->
    <b-row >
      <b-col sm="12">
        <b-card>
            <div class="my-1 row">

              <b-form-fieldset  class="col-sm-4" >
                <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}, {text:100,value:100}]" v-model="tabela.perPage">
                </b-form-select>
              </b-form-fieldset>

              <!--
              <b-form-fieldset horizontal label="Filter" class="col-6" :label-size="2">
                <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              </b-form-fieldset>
              -->
            </div>
          <!-- Main table element -->
          
  
          <b-table class="table table-sm"
                  show-empty
                  empty-text="Informe o filtro para ver as pesquisas "
                  stacked="md"
                  small
                  responsive 
                  :tbody-tr-class="rowClass"
                  striped 
                  hover 
                  :busy.sync="tabela.isBusy" 
                  :items="lista" 
                  :fields="tabela.campos"
                  :current-page="tabela.currentPage"
                  :per-page="tabela.perPage"
                  :filter="tabela.filter"
                  select-mode="single"
                  selectable
                  @row-selected="edit"
                  >
            <template #cell(STATUS_TRADUZIDO)="item">
              <b-badge pill :variant="colorirStatus(item.item.STATUS)">{{item.item.STATUS_TRADUZIDO}}</b-badge>
            </template>      
            <template #cell(actions)="item">
              <!--
              <b-button type="button" @click.stop.prevent="edit(item.item)"  size="sm" variant="primary" >
                <i class="fa fa-folder-open-o"></i>
              </b-button>
              -->
              <b-button type="button" title="Menus" @click.stop.prevent="abrirModalMenus(item.item)" size="sm" variant="warning" >
                <i class="fa fa-check-square-o"></i>
              </b-button>
              <b-button type="button" title="Permissões" @click.stop.prevent="abrirModalRotinas(item.item)" size="sm" variant="warning" >
                <i class="fa fa-plus-square-o"></i>
              </b-button>
            </template>
          </b-table>
          
          <div class="justify-content-center row my-1">
            <b-pagination size="md" :total-rows="this.lista.length" :per-page="tabela.perPage" v-model="tabela.currentPage" />
          </div>
          <h1>{{user}}</h1>
        </b-card>
      </b-col>
    </b-row>
    <!-- MODAL MENUS -->
    <b-modal 
      ref="modal-menus" 
      id="modal-acesso" 
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
      size="lg"
    >
      <!-- Cabeçalho Premium -->
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
           style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-list text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Menus do Sistema</h5>
          <small class="text-white opacity-75">Grupo: {{ registro.DESCRICAO }}</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-menus'].hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <!-- Corpo do Modal -->
      <div class="p-4">
        <div style="max-height: 60vh; overflow-y: auto;" class="border rounded shadow-sm">
          <b-table class="table table-sm table-premium mb-0"
                  show-empty
                  empty-text="Não existem menus disponíveis"
                  stacked="md"
                  small
                  striped
                  hover
                  :busy.sync="tabelaMenus.isBusy"
                  :items="tabelaMenus.items"
                  :fields="tabelaMenus.campos"
                  responsive="sm"
                  ref="tabelaMenus"
                  :tbody-tr-class="rowClassMenus">

            <template #cell(MARCA)="linha">
              <div class="d-flex justify-content-center py-1">
                <b-form-checkbox 
                  v-model="linha.item.MARCA" 
                  switch 
                  size="lg"
                  class="custom-switch-premium"
                  @change="onSelectMenu(linha.item)"
                ></b-form-checkbox>
              </div>
            </template>
            
            <template #cell(DESCRICAO)="linha">
              <span :style="{ paddingLeft: (linha.item.level * 20) + 'px' }" :class="linha.item.level === 0 ? 'font-weight-bold' : ''">
                <i v-if="linha.item.level === 0" class="fa fa-folder-open mr-2 text-primary opacity-75"></i>
                <i v-else class="fa fa-angle-right mr-2 text-muted"></i>
                {{ linha.item.DESCRICAO }}
              </span>
            </template>                    
          </b-table>
        </div>
        <div class="mt-2">
          <small class="text-muted italic">Selecione os menus que este grupo terá acesso.</small>
        </div>
      </div>

      <!-- Rodapé Premium -->
      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$refs['modal-menus'].hide()">
          FECHAR
        </b-button>
        <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click.stop.prevent="gravarMenus()">
          <i class="fa fa-save mr-1"></i> GRAVAR ACESSOS
        </b-button>
      </div>
    </b-modal>
    <!-- MODAL ROTINAS (Permissões do Sistema) -->
    <b-modal 
      ref="modal-rotinas" 
      id="modal-rotinas" 
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
      size="lg"
    >
      <!-- Cabeçalho Premium -->
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
           style="background: linear-gradient(135deg, #f6993f 0%, #d97706 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-shield text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Permissões do Sistema</h5>
          <small class="text-white opacity-75">Grupo: {{ registro.DESCRICAO }}</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-rotinas'].hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <!-- Corpo do Modal -->
      <div class="p-4">
        <!-- Barra de Pesquisa e Info -->
        <b-row class="mb-3 align-items-center">
          <b-col md="8">
            <b-input-group size="md">
              <b-input-group-prepend is-text class="bg-white border-right-0 rounded-left-pill shadow-xs">
                <i class="fa fa-search text-muted"></i>
              </b-input-group-prepend>
              <b-form-input 
                v-model="tabelaRotinas.filter" 
                placeholder="Pesquisar por descrição ou valor da permissão..." 
                class="border-left-0 rounded-right-pill shadow-xs"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col md="4" class="text-right">
            <small class="text-muted font-weight-bold">
              {{ tabelaRotinas.items.length }} Permissões Disponíveis
            </small>
          </b-col>
        </b-row>

        <div style="max-height: 55vh; overflow-y: auto;" class="border rounded shadow-sm">
          <b-table class="table table-sm table-premium mb-0"
                  show-empty
                  empty-text="Nenhuma permissão encontrada"
                  stacked="md"
                  small
                  striped 
                  hover 
                  :busy.sync="tabelaRotinas.isBusy" 
                  :items="tabelaRotinas.items" 
                  :fields="tabelaRotinas.campos"
                  :current-page="tabelaRotinas.currentPage"
                  :per-page="tabelaRotinas.perPage"
                  :filter="tabelaRotinas.filter"
                  responsive="sm"
                  ref="tabelaRotinas"
                  >
            
            <template #cell(MARCA)="linha">
              <div class="d-flex justify-content-center py-1">
                <b-form-checkbox 
                  v-model="linha.item.MARCA" 
                  value="1" 
                  unchecked-value="0"
                  switch 
                  size="lg"
                  class="custom-switch-premium"
                  @change="onSelectRotina([linha.item])"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(DESCRICAO)="linha">
              <div class="d-flex flex-column">
                <span class="font-weight-bold text-dark">{{ linha.item.DESCRICAO }}</span>
                <code class="small text-muted" style="background: transparent; padding: 0;">{{ linha.item.VALOR }}</code>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center text-primary my-4">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando permissões...</strong>
              </div>
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
          <small class="text-muted italic">As alterações são salvas automaticamente ao marcar/desmarcar.</small>
          <b-pagination 
            size="sm" 
            :total-rows="tabelaRotinas.items.length" 
            :per-page="tabelaRotinas.perPage" 
            v-model="tabelaRotinas.currentPage"
            class="mb-0"
            pills
          />
        </div>
      </div>

      <!-- Rodapé Premium -->
      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
        <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-xs" @click="$refs['modal-rotinas'].hide()">
          FECHAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import moment from 'moment'

export default {
  data () {
    return {
      registro: {},
      tabela: {
        campos: [
          {
            key: "ID",
            label: 'Id',
            sortable: true,
            _rowVariant: 'danger'
          },
          {
            key: "DESCRICAO",
            label: 'Descricao', 
            sortable: true 
          },
          {
            key: "STATUS_TRADUZIDO",
            label: 'Situação',
            sortable: true 
          },
          {
            key: "actions" ,
            label: 'Ações' 
          }
        ],
        currentPage: 1,
        perPage: 20,
        sortBy: null,
        sortDesc: false,
        filter: null,
        isLoading: false,
        status: '',
        isBusy: false,
      },
      tabelaMenus: {
        campos: [
           {
            key: "MARCA",
            label: 'Seleção',
            thStyle: {width: '50px !important'}
          },
          {
            key: "DESCRICAO",
            label: 'Descricao'
          }
         
        ],
        items:[],
        currentPage: 1,
        perPage: 10,
        sortBy: null,
        sortDesc: false,
        filter: null,
        isLoading: false,
        status: '',
        isBusy: false,
        selecionados:[]
      },
      tabelaRotinas: {
        campos: [
           {
            key: "MARCA",
            label: 'Acesso',
            sortable: true,
            thStyle: {width: '80px !important'},
            tdClass: 'text-center'
          },
          {
            key: "DESCRICAO",
            label: 'Descrição da Permissão / Ação', 
            sortable: true 
          }
        ],
        items:[],
        currentPage: 1,
        perPage: 10,
        sortBy: null,
        sortDesc: false,
        filter: null,
        isLoading: false,
        status: '',
        isBusy: false,
        selecionados:[]
      }

    }
  },
  components: {
    VueButtonSpinner
  },
  computed: {
    user () {
      return '' 
    },
   
    id: {
      get () {
        return this.$store.getters['grupoAcesso/ID']
      }, 
      set (value) {
        this.$store.commit("grupoAcesso/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['grupoAcesso/DESCRICAO']
      }, 
      set (value) {
        this.$store.commit("grupoAcesso/SET_DESCRICAO", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['grupoAcesso/LISTA']
      }, 
      set (value) {
        this.$store.commit("grupoAcesso/SET_LISTA", value);
      }
    }
  },
  methods: {
     limpar() {
      this.id = null
      this.descricao = null
      this.lista = []
    },
    rowClass(item, type) {
      if (item && type === 'row') {
        if ((item.STATUS_TRADUZIDO) && (item.STATUS_TRADUZIDO.trim() === 'CANCELADO')) {
          return 'text-danger'
        } else {
          return null
        } 
      } else {
        return null
      }
    },
    rowClassMenus(item, type) {
      if (item && type === 'row') {
        if ((item.GRUPO) && (item.GRUPO.trim() === '1')) {
          return 'font-weight-bold danger'
        } else {
          return null
        } 
      } else {
        return null
      }
    },
    colorirStatus(valor) {
      if (valor === '0') return 'danger'
      else if (valor === '1') return 'success'
      else 'info'
    },
    abrirModalRotinas(item){
      this.registro = item
      this.tabelaRotinas.isBusy = true
      let uri = this.$http.defaults.baseURL.concat(`api/protected/grupo/acesso/getRotinasByGrupoAcessoId/${item.ID}`)
      this.$http.get(uri)
      .then((data) => {
        if (data) {
            if (data.data) {
              this.tabelaRotinas.items = data.data
              this.tabelaRotinas.isBusy = false
              this.$refs['modal-rotinas'].show()
            } else {
              this.$root.$bvToast.toast(`Falha!!!  Ao localizar as Rotinas do Grupo`, {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'warning',
                appendToast: true
              })
              this.tabelaRotinas.isBusy = false
            }
        }
      })
      .catch(() => {
        this.$root.$bvToast.toast(`Falha!!!  Ao localizar as Rotinas do Grupo`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        this.tabelaMenus.isBusy = false
      })

    },
    onSelectRotina(items) {
      if (!items || items.length === 0) return

      const item = items[0]
      item.GRUPO_ACESSO_ID = this.registro.ID
      
      // Armazena o estado para reversão se necessário
      // Como o switch já mudou o v-model, o estado anterior é o oposto
      const estadoAnterior = item.MARCA === '1' ? '0' : '1'

      this.$http.post(`/api/protected/grupo/acesso/rotina/post`, item)
      .then(response => {
        if (response) {
          this.$root.$bvToast.toast(`Permissão "${item.DESCRICAO}" atualizada!`, {
            title: 'Segurança',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
        } else {
          item.MARCA = estadoAnterior
          this.$root.$bvToast.toast(`Não foi possível atualizar a permissão.`, {
            title: 'Aviso',
            variant: 'warning',
            appendToast: true
          })
        }
      })
      .catch((err) => {
        item.MARCA = estadoAnterior
        this.$root.$bvToast.toast(`Erro na comunicação com o servidor.`, {
          title: 'Erro',
          variant: 'danger',
          appendToast: true
        })
      })
    },
    abrirModalMenus(item){
      this.registro = item
      this.tabelaMenus.isBusy = true
      let uri = this.$http.defaults.baseURL.concat(`api/protected/grupo/acesso/getMenusByGrupoAcessoId/${item.ID}`)
      this.$http.get(uri)
      .then((data) => {
        if (data) {
            if (data.data) {
              let menus = data.data
              menus.forEach(child => {
                child.MARCA = child.MARCA === 1 ? true : false
              })
              let menuPais = this.buildMenuHierarchy(menus)
              this.tabelaMenus.items = this.flattenMenuHierarchy(menuPais);
              this.tabelaMenus.isBusy = false
              
              this.$refs['modal-menus'].show()
            } else {
              this.$root.$bvToast.toast(`Falha!!!  Ao localizar os Menus de Acesso`, {
                title: 'Aviso',
                autoHideDelay: 3000,
                variant: 'warning',
                appendToast: true
              })
              this.tabelaMenus.isBusy = false
            }
        }
      })
      .catch(() => {
        this.$root.$bvToast.toast(`Falha!!!  Ao localizar os Menus de Acesso`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        this.tabelaMenus.isBusy = false
      })

    },
    onSelectMenu(item) {
        // Verificar o estado atual do item (marcado ou não)
        const isChecked = item.MARCA;

        // Atualizar estado de todos os filhos recursivamente
        this.markChildren(item.MENU_ID, isChecked);
    },
    
    markChildren(parentId, checkStatus) {
        // Percorrer todos os itens
        this.tabelaMenus.items.forEach(child => {
            // Se o item é filho do parentId
            if (child.PAI_ID === parentId) {
                // Atualiza o estado de MARCA
                child.MARCA = checkStatus;
                // Chama recursivamente para marcar/desmarcar os filhos dos filhos
                this.markChildren(child.MENU_ID, checkStatus);
            }
        });
    },
    // Função para criar a hierarquia
    buildMenuHierarchy(menus) {
        // Criar um mapa dos menus por ID para acesso rápido
        let menuMap = {};
        
        menus.forEach(menu => {
            menu.children = []; // Adicionar um campo para os filhos
            menuMap[menu.MENU_ID] = menu;
        });

        // Criar a hierarquia
        let menuHierarchy = [];
        menus.forEach(menu => {
            if (menu.PAI_ID === null) {
                // Se não há PAI_ID, é um nó raiz
                menuHierarchy.push(menu);
            } else {
                // Se há PAI_ID, adicionar ao campo `children` do pai correspondente
                let parentMenu = menuMap[menu.PAI_ID];
                if (parentMenu) {
                    parentMenu.children.push(menu);
                }
            }
        });
        
        return menuHierarchy;
    },
    flattenMenuHierarchy(hierarchy, level = 0) {
      // Função para transformar a hierarquia em uma lista achatada com níveis de indentação
      let flatList = [];
      hierarchy.forEach(menu => {
        menu.level = level; // Adiciona nível para indentação
        flatList.push(menu);
        if (menu.children && menu.children.length > 0) {
          flatList = flatList.concat(this.flattenMenuHierarchy(menu.children, level + 1));
        }
      });
      return flatList;
    },
    gravarMenus(item) {
      this.$store.commit('controle/setAguardando', true)
      const menuIds =  this.tabelaMenus.items
        .filter(item => item.MARCA === true)  // Filtra os itens onde MARCA é 1
        .map(item => item.MENU_ID)        // Extrai apenas o valor de MENU_ID

      let pacote = {
        grupoAcessoId : this.registro.ID,
        menus : menuIds
      }
      this.$http.post(`/api/protected/grupo/acesso/menu/post`, pacote)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
        
        this.$refs['modal-menus'].hide()
        
        this.toastCount++
        this.$root.$bvToast.toast(`Sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 500,
          variant: 'success',
          appendToast: true
        })
          
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-menus'].hide()

        this.toastCount++

        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          this.$root.$bvToast.toast(msg, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.$root.$bvToast.toast(`Falha ao associar o Menu !! ${err}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }
      })
    },
    details (item) {
      alert(JSON.stringify(item.ID))
    },
    edit (item) {
      this.$router.push(`/seguranca/grupoacesso/edit/${item[0].ID}`)
    },
    novo () {
      this.$router.push(`/seguranca/grupoacesso/add`)
    },
    onPesquisar (ctx) {
      this.tabela.isBusy = true
      this.$store
      .dispatch('grupoAcesso/GERAR_LISTA')
      .then((data) => {
        this.tabela.isBusy = false
        this.status = true // or success
        return
      }).catch((error) => {
        if (error) {
          this.status = false // or error
        }
      })
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.opacity-75 {
  opacity: 0.75;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.rounded-left-pill {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-right-pill {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

.table-premium thead th {
  background-color: #f8fafc;
  color: #64748b;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  border-top: none;
}

.custom-switch-premium /deep/ .custom-control-label::before {
  height: 1.5rem;
  width: 2.75rem;
  border-radius: 2rem;
}

.custom-switch-premium /deep/ .custom-control-label::after {
  width: calc(1.5rem - 4px);
  height: calc(1.5rem - 4px);
  border-radius: 2rem;
}

.custom-switch-premium /deep/ .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #f6993f !important;
  border-color: #f6993f !important;
}

.soft-danger {
  background-color: #fee2e2;
  color: #ef4444;
  border: none;
}

.soft-danger:hover {
  background-color: #fecaca;
  color: #dc2626;
}

.italic {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/views/seguranca/grupoacesso/GrupoAcessoListagem.vue